__turbopack_context__.v({
  "animate": "ContentPlate-module__cBuq3G__animate",
  "backgroundWrapper": "ContentPlate-module__cBuq3G__backgroundWrapper",
  "copyBox": "ContentPlate-module__cBuq3G__copyBox",
  "flame": "ContentPlate-module__cBuq3G__flame",
  "flameBox": "ContentPlate-module__cBuq3G__flameBox",
  "foregroundImage": "ContentPlate-module__cBuq3G__foregroundImage",
  "foregroundWrapper": "ContentPlate-module__cBuq3G__foregroundWrapper",
  "frameBoxWrapper": "ContentPlate-module__cBuq3G__frameBoxWrapper",
  "inner": "ContentPlate-module__cBuq3G__inner",
  "root": "ContentPlate-module__cBuq3G__root",
});
